import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import ReportPageLayout from "@/components/reports/layout/ReportPageLayout";
import ReportFilterPanel, {
    ReportDateInput,
    ReportSelectInput,
} from "@/components/reports/layout/ReportFilterPanel";
import ExportBookingReportView from "@/components/reports/export/ExportBookingReportView";
import {
    EXPORT_BOOKING_LIST_COLUMNS,
    EXPORT_CONTAINER_TEUS_COLUMNS,
} from "@/components/reports/export/exportBookingReportColumns";
import { getFclExportBookingReport } from "@/redux/FCLExportReports/actions";
import { buildFclExportBookingParams } from "@/utility/fclReportHelpers";
import { defaultExportBookingFilters } from "@/pages/reports/shared/reportDefaults";
import { useFclReportLoader, useMountReportLoad } from "@/pages/reports/shared/useFclReportLoader";

const REPORT_BY_OPTIONS = [
    { value: "ETS", label: "ETS" },
    { value: "ETA", label: "ETA" },
];

const FclExportBookingReportPage = () => {
    const {
        exportBookingReportList,
        exportBookingReportSummary,
        exportBookingReportContainerTeus,
    } = useSelector((state) => state.fclExportReports);

    const [filters, setFilters] = useState(defaultExportBookingFilters);
    const { loadReport } = useFclReportLoader(getFclExportBookingReport, buildFclExportBookingParams);

    useMountReportLoad(loadReport, filters);

    const resetFilters = () => {
        const next = defaultExportBookingFilters();
        setFilters(next);
        loadReport(next);
    };

    const exportSheets = useMemo(() => {
        const sheets = [
            {
                name: "Booking List",
                data: exportBookingReportList || [],
                columns: EXPORT_BOOKING_LIST_COLUMNS,
            },
            {
                name: "Container TEUS",
                data: exportBookingReportContainerTeus || [],
                columns: EXPORT_CONTAINER_TEUS_COLUMNS,
            },
        ];
        if (exportBookingReportSummary && Object.keys(exportBookingReportSummary).length > 0) {
            sheets.push({ name: "Summary", data: [exportBookingReportSummary] });
        }
        return sheets;
    }, [exportBookingReportList, exportBookingReportContainerTeus, exportBookingReportSummary]);

    return (
        <ReportPageLayout
            compactTop
            title="Booking Report"
            breadcrumb="OCEAN FREIGHT • EXPORT • REPORTS"
            hubPath="/ocean/export/reports"
            onRefresh={() => loadReport(filters)}
            exportSheets={exportSheets}
            exportFileName="Export_Booking_Report"
            filterPanel={
                <ReportFilterPanel onSubmit={() => loadReport(filters)} onReset={resetFilters}>
                    <ReportDateInput
                        label="From date"
                        name="FromDate"
                        value={filters.FromDate}
                        onChange={(field, val) => setFilters((p) => ({ ...p, [field]: val ?? "" }))}
                    />
                    <ReportDateInput
                        label="To date"
                        name="ToDate"
                        value={filters.ToDate}
                        onChange={(field, val) => setFilters((p) => ({ ...p, [field]: val ?? "" }))}
                    />
                    <ReportSelectInput
                        label="Report by"
                        value={filters.ReportBy}
                        onChange={(e) => setFilters((p) => ({ ...p, ReportBy: e.target.value }))}
                        options={REPORT_BY_OPTIONS}
                    />
                </ReportFilterPanel>
            }
        >
            <ExportBookingReportView
                filters={filters}
                summary={exportBookingReportSummary}
                containerTeusList={exportBookingReportContainerTeus}
                bookingList={exportBookingReportList}
            />
        </ReportPageLayout>
    );
};

export default FclExportBookingReportPage;
